import { Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { Ticket } from "@app/models/rest/ticket";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { IntegrationService } from "@app/services/http/integration.service";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-ticket-completion-utility",
  templateUrl: "./ticket-completion-utility.component.html",
  styleUrls: ["./ticket-completion-utility.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatCheckbox,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslatePipe
  ]
})
export class TicketCompletionUtilityComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<TicketCompletionUtilityComponent>>(MatDialogRef);
  formBuilder = inject(UntypedFormBuilder);
  integrationService = inject(IntegrationService);
  data = inject<{
    ticket: Ticket;
  }>(MAT_DIALOG_DATA);

  public completionForm: UntypedFormGroup;
  public submitting = false;

  ngOnInit() {
    this.completionForm = this.formBuilder.group({
      completionCode: "",
      followOnNote: "",
      followOnRequired: false
    });
  }

  async onCompleteTicket() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    try {
      await this.integrationService.ticketCompletion({
        ticketId: this.data.ticket.id,
        completionTime: new Date(),
        followOnNotes: this.completionForm.controls["followOnNote"].value,
        followOnRequired:
          this.completionForm.controls["followOnRequired"].value,
        completionCode: this.completionForm.controls["completionCode"].value
      });
      this.dialogRef.close({ completed: true });
    } catch (error) {
      console.error("Error completing ticket", error);
      this.submitting = false;
    }
  }
}
